import { formatNumber, formatPercent as formatFraction } from '../../i18n/format';

/** Display count for stats; never invent a number while loading. */
export function formatCount(value: number | undefined, isPending: boolean): string {
  if (isPending) return '—';
  if (value === undefined) return '—';
  return formatNumber(value);
}

export function formatPercent(part: number, whole: number): string | null {
  if (whole <= 0) return null;
  return formatFraction(part / whole);
}
